import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { styled } from "@mui/system";
import { colors } from "../config/colors";
import { Typography } from "@mui/material";
import { USER_MANAGEMENT_CONSTANTS } from "../config/constants";
import { SessionInfoLogo } from "../assets/icons";
import {
  DISPLAY_FLEX,
  FLEX_ALIGN_CENTER,
  FLEX_DIRECTION_COLUMN,
  MAX_WIDTH,
} from "../config/styles";

const SessionExpiredModalStyled = styled(Modal)(({ theme }) => ({
  "& .modal-content": {
    maxWidth: "400px",
    margin: "auto",
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
  },
  "& .modal-header": {
    border: "none",
  },
  '& .modal-title': {
    textAlign: "center",
  },
  "& .modal-body": {
    alignItems: FLEX_ALIGN_CENTER,
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    gap: "1rem",
  },
  "& .modal-footer": {
    display: "flex",
    justifyContent: "center",
  },
  "& .session-expired-text": {
    ...theme.typography.body1,
    color: colors.textPrimary,
    marginBottom: "1rem",
  },
  "& .login-button": {
    width: MAX_WIDTH,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.contrastText,
    border: "none",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

export const SessionExpiredModal = ({ show, onHide, title, subTitle, buttonText, showSubTitle }) => {
  return (
    <SessionExpiredModalStyled show={show} onHide={onHide} centered size="sm">
      <Modal.Header closeButton />
      <Modal.Body>
        <SessionInfoLogo />
        <Modal.Title>{title || USER_MANAGEMENT_CONSTANTS.SESSION_EXPIRED}</Modal.Title>
        <Typography className="session-expired-text">
          {showSubTitle ? subTitle : USER_MANAGEMENT_CONSTANTS.SESSION_EXPIRED_MESSAGE}
        </Typography>
      </Modal.Body>
      <Modal.Footer>
        <Button className="login-button" onClick={onHide}>
          {buttonText || USER_MANAGEMENT_CONSTANTS.SESSION_EXPIRED_BUTTON}
        </Button>
      </Modal.Footer>
    </SessionExpiredModalStyled>
  );
};
SessionExpiredModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  buttonText: PropTypes.string,
  showSubTitle: PropTypes.bool,
};
